import Icon from "@visa/vds/icon";
import Td from "@visa/vds/td";
import Tr from "@visa/vds/tr";
import React from "react";
import MCSPagedTable from "../../../components/MCSPagedTable";
import { DateHelper } from "../../../_helpers/DateHelper";

function VmidTable(props) {
  const isExternalUser =
    !props.user.isSuperAdmin && !props.user.isVmidParticipation;

  let colHeaders = [
    { displayName: "VMID", name: "vmid", orderable: true },
    {
      displayName: "VMID Merchant Name",
      name: "vmidMerchantName",
      orderable: true,
    },
    {
      displayName: "3DS DAF Global Product Participation (Flag 1)",
      name: "flagOneName",
      orderable: true,
      hidden: !props.showFlag,
    },
    {
      displayName: "3DS DAF Global Performance Participation (Flag 2)",
      name: "flagTwoName",
      orderable: true,
      hidden: !props.showFlag,
    },
    {
      displayName: "3DS DAF EU Product Participation (Flag 3)",
      name: "flagThreeName",
      orderable: true,
      hidden: !props.showFlag,
    },
    {
      displayName: "3DS DAF EU Performance Participation (Flag 4)",
      name: "flagFourName",
      orderable: true,
      hidden: !props.showFlag,
    },
    {
      displayName: "3DS DAF Global Participation (Parameter A)",
      name: "parameterA",
      orderable: true,
      hidden: !props.showParam,
    },
    {
      displayName: "3DS DAF EU Participation (Parameter B)",
      name: "parameterB",
      orderable: true,
      hidden: !props.showParam,
    },
    {
      displayName: "Created On",
      name: "createdOn",
      orderable: true,
      hidden: isExternalUser,
    },
    {
      displayName: "Last Updated On",
      name: "lastUpdatedOn",
      orderable: true,
      hidden: isExternalUser,
    },
    {
      displayName: "Last Updated By",
      name: "lastUpdatedBy",
      orderable: true,
      hidden: isExternalUser,
    },
    {
      displayName: "",
      name: "action",
      orderable: false,
      hidden: !props.user.isSuperAdmin,
    },
  ];

  return (
    <>
      <MCSPagedTable
        size={"compact"}
        colHeaders={colHeaders}
        useSearchBar={true}
        searchVal={props.searchVal}
        setSearchVal={props.setSearchVal}
        searchHelpText="Search VMID/Merchant Name"
        handleSearchChange={props.handleSearchChange}
        usePagination={true}
        selectedPage={props.selectedPage}
        setSelectedPage={props.setSelectedPage}
        totalPages={props.totalPages}
        ordered={props.ordered}
        setOrdered={props.setOrdered}
        sortData={props.sortData}
        isDsc={props.isDsc}
        setDsc={props.setDsc}
        pageSize={props.pageSize}
        totalCount={props.totalCount}
        tableData={
          props.tableData &&
          props.tableData.map((row, key) => (
            <Tr key={key}>
              <Td>{row.vmid}</Td>
              <Td>{row.vmidMerchantName}</Td>
              {props.showFlag && (
                <>
                  <Td>{row.flagOneName}</Td>
                  <Td>{row.flagTwoName}</Td>
                  <Td>{row.flagThreeName}</Td>
                  <Td>{row.flagFourName}</Td>
                </>
              )}
              {props.showParam && (
                <>
                  <Td>{row.parameterAName}</Td>
                  <Td>{row.parameterBName}</Td>
                </>
              )}
              {!isExternalUser && (
                <>
                  <Td>{DateHelper.ToLocaleDateString(row.createdOn)}</Td>
                  <Td>{DateHelper.ToLocaleDateString(row.lastUpdatedOn)}</Td>
                  <Td>{row.lastUpdatedBy}</Td>
                </>
              )}
              {props.user.isSuperAdmin && (
                <Td style={{ textAlign: "right" }}>
                  <Icon
                    data-id={row.id}
                    onClick={props.handleClickAction}
                    className="vss-clickable-icon"
                    name="settings"
                    resolution="low"
                  />
                </Td>
              )}
            </Tr>
          ))
        }
      />
    </>
  );
}

export default VmidTable;
